
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';


import { useNavigate } from 'react-router-dom';
import React, { useState, useContext, useEffect } from 'react';

import { ArrowLeft, Sparkles, Star, Zap, Crown, Check, Shield } from 'lucide-react';
import '../../../../assets/css/screens/serviceprovider/dashboard/subscription/SubscriptionPlan.css';
import SubscriptionSkeleton from "../../../../components/skeltonloading/SubscriptionSkeleton";
import axios from 'axios';
import AppContext from '../../../../context/AppContext';



const TIER_ICON = {
  Basic: <Zap size={18} />,
  Pro: <Star size={18} />,
  Elite: <Crown size={18} />,
};
// Tier gradient map
const TIER_CLASS = {
  Basic: 'wsp-card--starter',
  Pro: 'wsp-card--pro',
  Elite: 'wsp-card--elite',
};
const WorkerSubscription = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);
  const [subscription, setSubscription] = useState([]);
  const [loadingPlan, setLoadingPlan] = useState(null);
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const isCurrentPlan = (plan) => {
    return currentSubscription?.id === plan.id;
  };

  const isDowngrade = (plan) => {

    if (!currentSubscription) return false;

    return plan.price < currentSubscription.price;

  };
  const viewsubscriptions = async () => {
    setLoading(true);
    const authToken = localStorage.getItem('authToken');
    axios.get(`${baseUrl}/worker/subscriptionplan`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem("authToken") || ""}`
        },
      }
    )
      .then((response) => {
        console.log(response.data);
        console.log(response.data.subscriptions);
        setSubscription(response.data.subscriptions);
        console.log("Full Response:", response.data);
console.log("Subscriptions:", response.data.subscriptions);
console.log("Is Array:", Array.isArray(response.data.subscriptions));
        setCurrentSubscription(
          response.data.current_subscription
        );

      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
      setLoading(false);
    });
  }
  const handleSubscribe = async (planId) => {
    try {
      setLoadingPlan(planId);
      const response =
        await axios.post(
          `${baseUrl}/subscription/checkout`,
          {
            subscription_id: planId,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              'Content-Type': 'application/json',
            },
          }
        );
      console.log(response.data);
      if (response.data.success) {
        window.location.href = response.data.checkout_url;
      }

    } catch (error) {
      console.log(error.response);
      console.log(error.response.data);
      setLoadingPlan(null);
    }
  };
  useEffect(() => {
    viewsubscriptions();
  }, []);

if (loading) {
  return (
    <>
      <WorkerNavbar />
      <SubscriptionSkeleton />
    </>
  );
}
  return (
    <>
      <WorkerNavbar />

      <div className="wsp-page">
       

        {/* ── Back ── */}
        <div className="wsp-header-back">

          <button className="wsp-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
          </button>

          <h2 className="wsp-back-title">
            Subscriptions
          </h2>


        </div>
        {/* ── Hero heading ── */}
        <div className="wsp-hero">
          <div className="wsp-hero__badge">
            <Sparkles size={13} /> Premium Membership
          </div>
          <h1 className="wsp-hero__title">Choose Your Plan</h1>
          <p className="wsp-hero__sub">
            Unlock premium features, get priority access, and enjoy a seamless Picks4Tips experience.
          </p>
        </div>

        {/* ── Plans Grid ── */}
        <div className="wsp-grid">
          {subscription.map((plan, i) => (
            <div
              key={plan.id}
              className={`wsp-card ${TIER_CLASS[plan.tier] || 'wsp-card--basic'}`}
            >
              {/* Popular badge */}
              {plan.popular && (
                <div className="wsp-popular-badge">Most Popular</div>
              )}

              {/* Icon */}
              <div className="wsp-card__icon">
                {TIER_ICON[plan.tier] || <Star size={18} />}
              </div>
              {/* Name */}
              <h3 className="wsp-card__name">{plan.planName}</h3>

              {/* Price */}
              <div className="wsp-card__price-row">
                <span className="wsp-card__price">${plan.price}</span>
                <span className="wsp-card__period">/ {plan.duration}</span>
              </div>
              {/* Divider */}
              <div className="wsp-card__divider" />
              {/* Features */}
              <ul className="wsp-card__features">
                {plan.features?.map((feature, index) => (
                  <li key={index}>
                    <span className="wsp-card__check">
                      <Check size={13} />
                    </span>
                    <strong>{feature.feature_name}</strong>
                    {feature.feature_value &&
                      <> : {feature.feature_value}</>
                    }
                  </li>
                ))}
              </ul>
              {/* Subscribe button */}
              <button

                className={
                  `wsp-card__btn
           
           ${isCurrentPlan(plan)
                    ?
                    "wsp-card__btn--current"
                    :
                    isDowngrade(plan)
                      ?
                      "wsp-card__btn--disabled"
                      :
                      plan.popular
                        ?
                        "wsp-card__btn--primary"
                        :
                        ""
                  }
           `
                }
                onClick={() => {
                  if (isDowngrade(plan)) {
                    alert(
                      `You can switch to this plan after ${currentSubscription.end_date}`
                    );
                    return;
                  }
                  handleSubscribe(plan.id);
                }}
                disabled={
                  loadingPlan === plan.id ||
                  isCurrentPlan(plan)
                }>
                {
                  isCurrentPlan(plan)
                    ?
                    <>
                      <Check size={15} />
                      Current Plan
                    </>
                    :
                    isDowngrade(plan)
                      ?
                      "Available After Expiry"
                      :
                      loadingPlan === plan.id
                        ?
                        "Loading..."
                        :
                        currentSubscription
                          ?
                          "Upgrade Now"
                          :
                          "Subscribe Now"
                }
              </button>
            </div>
          ))}
        </div>
        {/* ── Footer note ── */}
        <div className="wsp-footer-note">
          <Shield size={14} /> Secured payments. Cancel anytime.
        </div>
      </div>
    </>
  );
};
export default WorkerSubscription;